import { render, staticRenderFns } from "./FormList.vue?vue&type=template&id=2dacadf1"
import script from "./FormList.vue?vue&type=script&lang=js"
export * from "./FormList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/CoreProductivity.Backoffice.Mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2dacadf1')) {
      api.createRecord('2dacadf1', component.options)
    } else {
      api.reload('2dacadf1', component.options)
    }
    module.hot.accept("./FormList.vue?vue&type=template&id=2dacadf1", function () {
      api.rerender('2dacadf1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/form/FormList.vue"
export default component.exports